"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.function.name");




























































































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'SkillItem', props: ['itemListShow', 'skillId'], data: function data() {return { skilItemData: [], // 列表数据
      displayList: [{ 'value': 'radio' }, { 'value': 'audio' }, { 'value': 'video' }, { 'value': 'img' }, { 'value': 'checkbox' }, { 'value': 'input' }, { 'value': 'textArea' }, { 'value': 'numberInput' }, { 'value': 'select' }, { 'value': 'time' }], dataTypeList: ['string', 'int'], addItem: false, showItemList: true, skillItemId: '', title: '', searchData: { page: 1, // 页码条数
        rows: 10 }, addData: { id: '', name: '', code: '', display: '', option: '', value: '', dataType: '' }, rules: { name: [{ required: true, message: '请输入技能名称', trigger: 'blur' }], code: [{ required: true, message: '请输入技能编码', trigger: 'blur' }, { validator: this.isRedundant, trigger: 'blur' }], dataType: [{ required: true, message: '请输入数据类型', trigger: 'blur' }], display: [{ required: true, message: '请输入展示方式', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'code', label: '编码', isShow: true }, { prop: 'name', label: '名称', isShow: true }, { prop: 'dataType', label: '数据类型', isShow: true }, { prop: 'display', label: '展示方式', isShow: true }, { prop: 'option', label: '可选项', isShow: true }, { prop: 'value', label: '默认值', formatter: function formatter(columns, index, val) {return val + '';}, isShow: true }] };}, mounted: function mounted() {var self = this;self.getItem(self.skillId);}, methods: { getItem: function getItem(skillId) {
      var self = this;
      self.skillItemId = skillId;
      self.getData('/api/temi/robot/skill/param/' + skillId, self.searchData, function (res) {
        console.log(res);
        self.skilItemData = res;
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.code = '';
      this.searchData.name = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addItem = true;
      // this.$emit('changeItemShow', false)
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addSkillItem'].resetFields();
      this.cleanData();
      this.addItem = false;
      this.addItem2 = false;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      var self = this;
      self.addItem = true;
      self.addData = {
        name: item.name,
        code: item.code,
        option: item.option,
        dataType: item.dataType,
        display: item.display,
        value: item.value,
        id: self.skillItemId };

    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addSkillItem.validate(function (valid) {
        if (valid) {
          self.skilItemData = self.skilItemData ? self.skilItemData : [];
          if (self.title === '新增') {
            self.skilItemData.forEach(function (item) {
              if (item.code === self.code) {
                console.log(item);
                self.$message({ message: '编码已经存在!', type: 'error' });
                return false;
              }
            });
            self.skilItemData.push(self.addData);
          } else {
            for (var index in self.skilItemData) {
              if (self.skilItemData[index].code === self.addData.code) {
                self.skilItemData[index] = self.addData;
              }
            }
          }
          console.log(self.skilItemData);
          self.postData('/api/temi/robot/skill/param/' + self.skillItemId, self.skilItemData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.getItem(self.skillItemId);
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(code) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        for (var index in self.skilItemData) {
          if (self.skilItemData[index].code === code) {
            self.skilItemData.splice(index, 1);
          }
        }
        console.log(self.skilItemData);
        self.postData('/api/temi/robot/skill/param/' + self.skillItemId, self.skilItemData, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.onCencal();
          self.getItem(self.skillItemId);
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addItem = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '',
        code: '' };

    },
    isRedundant: function isRedundant(rule, value, callback) {
      var self = this;
      if (self.title === '修改') {
        callback();
      }
      self.skilItemData = self.skilItemData ? self.skilItemData : [];
      self.skilItemData.forEach(function (item) {
        if (item.code === self.addData.code) {
          callback(new Error('编码已经存在'));
          return false;
        }
      });
      callback();
    },
    querySearch: function querySearch(queryString, cb) {
      var restValue = this.displayList;
      var results = queryString ? restValue.filter(this.createFilter(queryString)) : restValue;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (displayList) {
        return displayList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    } } };exports.default = _default;